// extracted by mini-css-extract-plugin
module.exports = {"textArea":"GiftCardMessageInput_textArea__hf5jy"};